import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { Link } from "@msuite/ui/link";
import { OrderStateTag } from "@msuite/ui/tag";
import { getDeliveryWindowString, getOrderNumberString } from "@msuite/utils/stock";
import { guardString } from "@msuite/utils/strings";
import { useOrder } from "@/hooks/use-order";
import type { OrderPanelBaseProps } from "./shared";

export function OrderHeader({ orderId }: OrderPanelBaseProps) {
	/** Query */
	const { order } = useOrder(orderId);

	/** Guard */
	if (!order) return null;

	/** Render */
	return (
		<ContentCard
			icon={icon("Truck")}
			title={getOrderNumberString(order.number)}
			identifier={order.id}
		>
			<div className="justify-between items-center h-stack">
				<div className="h-stack">
					<OrderStateTag state={order.state} />
					<Link href={`/projects/${order.projectId}`}>{guardString(order.projectName)}</Link>
				</div>
				<p className="tabular-nums">
					{getDeliveryWindowString(order.deliveryDate, order.tourWave)}
				</p>
			</div>
		</ContentCard>
	);
}
